import { ColumnDef } from '@tanstack/react-table';
import Icons from '../../../../../../../../../components/Common/Icons/Icons';
import { DownloadPdfLink } from '../../../subTableConfig';

export interface DivertedSamplesRes {
  accountName: string;
  accountNumber: string;
}

export const getDivertedCol = (onRemove: (accountNumber: string) => void): ColumnDef<DivertedSamplesRes>[] => [
  {
    accessorKey: 'accountName',
    header: 'Name',
  },
  {
    accessorKey: 'accountNumber',
    header: 'Account',
  },
  {
    accessorKey: 'sample',
    header: 'Sample',
    cell: () => <DownloadPdfLink />,
  },
  {
    id: 'removeDivertedSample',
    header: 'Remove Diverted Sample',
    cell: ({ row }) => (
      <button
        type="button"
        aria-label="Remove diverted document"
        onClick={() => onRemove(row.original.accountNumber)}
      >
        <Icons.PDF className="text-red-600" />
      </button>
    ),
  },
];
